<template>
  <main-layout>
    <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'ChannelManager'" :href="'#ChannelManager'">{{
        $t('จัดการ Channel')
      }}</v-tab>
      <v-tab ripple :key="'PageGroup'" :href="'#PageGroup'">{{ $t('กลุ่มเพจ/LINE OA') }}</v-tab>
    </v-tabs>
    <div>
      <div v-if="tabs == 'ChannelManager'">
        <ChannelManager></ChannelManager>
      </div>
      <div v-else-if="tabs == 'PageGroup'">
        <PageGroup></PageGroup>
      </div>
    </div>
  </main-layout>
</template>

<script>
import ChannelManager from './ChannelManager.vue'
import PageGroup from './PageGroup.vue'
export default {
  components: {
    ChannelManager,
    PageGroup
  },
  data() {
    return {
      tabs: 'ChannelManager'
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.tabs = vm.$route.query.tab
    } else {
      vm.tabs = 'ChannelManager'
    }
  },
  methods: {},
  watch: {
    tabs: function () {
      //   this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/main.vue